<template>
	<g>
		<g>
			<polygon fill="#EFEBDE" stroke="#8697CB" stroke-width="4" stroke-miterlimit="10" points="47.4,16.5 33.4,2.5 2.4,2.5 2.4,60.5
			47.4,60.5 		"/>
			<polygon fill="#EFEBDE" points="47.4,16.5 33.4,2.5 2.4,2.5 2.4,60.5 47.4,60.5 		"/>
			<g>
				<path fill="#D5D0BB" d="M12.4,25.5h25c0.6,0,1-0.4,1-1s-0.4-1-1-1h-25c-0.6,0-1,0.4-1,1S11.8,25.5,12.4,25.5z"/>
				<path fill="#D5D0BB" d="M12.4,17.5h10c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-10c-0.6,0-1,0.4-1,1C11.4,17.1,11.8,17.5,12.4,17.5z"/>
				<path fill="#D5D0BB" d="M37.4,31.5h-25c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h25c0.6,0,1-0.4,1-1C38.4,31.9,37.9,31.5,37.4,31.5z"/>
				<path fill="#D5D0BB" d="M37.4,39.5h-25c-0.6,0-1,0.4-1,1s0.4,1,1,1h25c0.6,0,1-0.4,1-1S37.9,39.5,37.4,39.5z"/>
				<path fill="#D5D0BB" d="M37.4,47.5h-25c-0.6,0-1,0.4-1,1s0.4,1,1,1h25c0.6,0,1-0.4,1-1S37.9,47.5,37.4,47.5z"/>
			</g>
			<polygon fill="#D5D0BB" points="33.4,2.5 33.4,16.5 47.4,16.5 		"/>
		</g>
		<g>
			<g id="IconFile--cloud">
				<path fill="#91BAE1" d="M56.4,47.6c0-3.9-3.2-7.1-7-7.1c-2.6,0-4.8,1.4-6,3.5c-0.4-0.1-0.9-0.2-1.3-0.2c-2.1,0-3.8,1.5-4.2,3.5
				c-1.8,0.9-3,2.7-3,4.8c0,2.9,2.3,5.4,5.2,5.4h10.8c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0h4.3c2.7,0,4.8-2.2,4.8-5
				C60.4,50.1,58.7,48,56.4,47.6z"/>
				<path fill="#8697CB" d="M55.5,58.5h-4.3c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0H40.1c-3.4,0-6.2-2.9-6.2-6.4
				c0-2.3,1.2-4.4,3.1-5.5c0.7-2.2,2.7-3.8,5.1-3.8c0.3,0,0.6,0,0.9,0.1c1.5-2.1,3.9-3.4,6.5-3.4c4.1,0,7.5,3.2,8,7.3
				c2.4,0.8,4,3.1,4,5.7C61.4,55.8,58.8,58.5,55.5,58.5z M51,56.5l0.2,0l4.3,0c2.1,0,3.8-1.8,3.8-4c0-1.9-1.3-3.6-3.1-3.9l-0.8-0.2
				l0-0.8c0-3.4-2.7-6.1-6-6.1c-2.1,0-4.1,1.1-5.2,3l-0.4,0.7L43.1,45c-0.3-0.1-0.7-0.2-1-0.2c-1.5,0-2.9,1.1-3.2,2.7L38.7,48
				l-0.4,0.2c-1.5,0.7-2.4,2.3-2.4,3.9c0,2.4,1.9,4.4,4.2,4.4L51,56.5z"/>
			</g>
		</g>
	</g>
</template>

<script>
	import { TimelineMax  } from 'gsap'

	export default {
		name: "IconFile.vue",
		data: function () {
			return {
				tl:undefined,
			}
		},
		methods:{
			start() {
				this.tl = new TimelineMax({repeat: -1});
				this.tl.set('#IconFile--cloud', { scale: 1, transformOrigin: "center" })
				this.tl.to('#IconFile--cloud',0.5, { scale: 1.1, transformOrigin: "center" });
				this.tl.to('#IconFile--cloud', 1, { scale: 1, transformOrigin: "center" })
			},
			stop() {
				this.tl.stop();
			},
			pause() {
				this.tl.pause();
			},
			play() {
				if (this.tl.paused()) {
					this.tl.play();
				}
			}
		}
	}
</script>

<style scoped>

</style>
